import { useEffect, useState } from 'react';
import {
    fetchCustomerDetails,
    updateCustomerDetails,
} from '../api/customer-details';

export const useCustomerDetails = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let cancelled = false;

        fetchCustomerDetails()
            .then((resp) => {
                if (cancelled) 
                    return;

                setData(resp);
                setError(null);
            })
            .catch((err) => {
                console.error('Failed to load customer details', err);
                if (!cancelled) {
                    setError(err || new Error('Failed to load'));
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, []);

    const save = async (payload) => {
        const result = await updateCustomerDetails(payload);

        if (!result || result.success === false) {
            const err = new Error('Unable to save customer details');
            err.result = result;
            throw err;
        }

        const refreshed = await fetchCustomerDetails();
        setData(refreshed);
        return refreshed;
    };

    return { data, loading, error, save };
};
